import React from "react";
import { FiTrash2 } from "react-icons/fi";

const ProviderFields = ({ providers, errors = {}, onChange }) => {
  const getInputClass = (hasError) => {
    return `form-input border ${hasError ? "border-red-500" : "border-mediumgray"}`;
  };

  const updateProvider = (index, field, value) => {
    onChange(
      providers.map((provider, providerIndex) =>
        providerIndex === index ? { ...provider, [field]: value } : provider
      )
    );
  };

  const removeProvider = (index) => {
    if (providers.length <= 1) return;
    onChange(providers.filter((_, providerIndex) => providerIndex !== index));
  };

  return (
    <div>
      <label className="form-label">Providers</label>
      {providers.map((provider, index) => {
        const providerErrors = errors[index] || {};
        const hasContactError = providerErrors.contact;

        return (
          <div
            key={index}
            className="mb-3 p-3 bg-lightergray rounded border border-mediumgray"
          >
            <div className="flex flex-col items-center gap-2">
              <input
                type="text"
                value={provider.name}
                onChange={(e) => updateProvider(index, "name", e.target.value)}
                className={`${getInputClass(providerErrors.name)} flex-1`}
                placeholder="Name *"
              />
              <input
                type="text"
                value={provider.phone}
                onChange={(e) => updateProvider(index, "phone", e.target.value)}
                className={`${getInputClass(hasContactError)} flex-1`}
                placeholder="Phone"
              />
              <input
                type="email"
                value={provider.email}
                onChange={(e) => updateProvider(index, "email", e.target.value)}
                className={`${getInputClass(
                  hasContactError || providerErrors.email
                )} flex-1`}
                placeholder="Email"
              />
              {providers.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeProvider(index)}
                  className="outline-button text-red-600 px-2"
                  aria-label="Remove provider"
                >
                  <FiTrash2 />
                </button>
              )}
            </div>
            {providerErrors.name && (
              <p className="text-red-500 text-sm mt-1">{providerErrors.name}</p>
            )}
            {providerErrors.contact && (
              <p className="text-red-500 text-sm mt-1">
                {providerErrors.contact}
              </p>
            )}
            {providerErrors.email && (
              <p className="text-red-500 text-sm mt-1">{providerErrors.email}</p>
            )}
          </div>
        );
      })}
      <button
        type="button"
        onClick={() => onChange([...providers, { name: "", phone: "", email: "" }])}
        className="outline-button text-sm mt-2"
      >
        + Add Another Provider
      </button>
    </div>
  );
};

export default ProviderFields;
